import React, { Component } from 'react'
import InstanciaBasic from './InstanciaBasic.js'
import * as Constants from '../constants.js'
import { TIPOS_UNIDAD_MEDIDOR as UNIDAD_MEDIDOR, ID__UM_ODOMETRO } from '../../unidadMedidor/constants.js'
import moment from 'moment'
import swal from 'sweetalert'
import { FormattedMessage, injectIntl } from 'react-intl'
import UnitSystem from '../../../commons/utils/UnitSystem.js'
import { getToleranciaOdometro, isControlOdometroHabilitado, superaTolerancia, fetchProyeccionOdometro } from './odometroChecklist.js'

export class InstanciaMedidor extends InstanciaBasic {
	constructor(props) {
    super(props);
		this.castValue = this.castValue.bind(this);
		this.recalcularEstado = this.recalcularEstado.bind(this);
		this.checkInvalid = this.checkInvalid.bind(this);
	}

	t(id, defaultMessage, values) {
		return this.props.intl.formatMessage({ id: id, defaultMessage: defaultMessage }, values)
	}

	recalcularEstado(value) {
		value = this.castValue(value)
		let medidorAnterior = this.castValue(this.props.movil ? this.props.movil.km_actual : 0)
		// VEC-3990: tolerancia dinámica (moviles.editaKm.maximo) en vez del 1000 fijo
		let tolerancia = getToleranciaOdometro()
		if (value && medidorAnterior !== undefined) {
			// VEC-3990: en el alta de checklist, un móvil sin odómetro previo (0 o NULL) no tiene contra qué
			// compararse y queda exento de la tolerancia, igual que en el backend. Fuera del checklist, como siempre.
			if (this.props.validarOdometroChecklist && !(medidorAnterior > 0))
				return Constants.ID_ESTADO_APROBACION_VALIDO

			if (value < medidorAnterior - tolerancia)
				return Constants.ID_ESTADO_APROBACION_INVALIDO

			if (value > medidorAnterior + tolerancia)
				return Constants.ID_ESTADO_APROBACION_INVALIDO

			return Constants.ID_ESTADO_APROBACION_VALIDO
		}
		else 
			return Constants.ID_ESTADO_APROBACION_SIN_COMPROBACION
		
	}

	// VEC-3990: swal con un solo botón "Aceptar"; resuelve true/falsy según el usuario.
	avisar(title, text, content) {
		let opciones = {
			title: title,
			text: text || "",
			icon: "warning",
			buttons: {
				confirm: {
					text: this.t('InstanciaMedidor.checkInvalid.aceptar', 'Aceptar'),
					value: true,
					visible: true,
					className: "btn btn-success",
					closeModal: true
				},
			}
		}
		if (content) opciones.content = content
		return swal(opciones)
	}

	// VEC-3990: tabla (nodo DOM) con la proyección de odómetro de las llantas.
	armarTablaProyeccion(llantas) {
		let tabla = document.createElement('table')
		tabla.className = 'table table-sm'
		let encabezado = tabla.createTHead().insertRow()
		;[
			this.t('InstanciaMedidor.proyeccion.llanta', 'Llanta'),
			this.t('InstanciaMedidor.proyeccion.odometro_actual', 'Odómetro actual'),
			this.t('InstanciaMedidor.proyeccion.odometro_resultante', 'Odómetro resultante'),
		].forEach(texto => {
			let th = document.createElement('th')
			th.textContent = texto
			encabezado.appendChild(th)
		})
		let cuerpo = tabla.createTBody()
		llantas.forEach(llanta => {
			let fila = cuerpo.insertRow()
			;[llanta.serial, llanta.odometro_actual, llanta.odometro_resultante].forEach(dato => {
				fila.insertCell().textContent = dato === null || dato === undefined ? '' : String(dato)
			})
		})
		let contenedor = document.createElement('div')
		contenedor.appendChild(tabla)
		return contenedor
	}

	checkInvalid() {
		if (!this.props.validarOdometroChecklist) {
			let estado = this.recalcularEstado(this.props.atributo[this.valueKey])
			// TODO: Ver tema que this.props.movil llega sin el modelo
			let title = this.t('InstanciaMedidor.checkInvalid.titulo', 'La diferencia del medidor es mayor a {tolerancia} unidades.', { tolerancia: getToleranciaOdometro() });
			if (estado == Constants.ID_ESTADO_APROBACION_INVALIDO) {
				return this.avisar(title).then(isConfirm => {
					if (isConfirm)
						this.props.handleChange("estado", Constants.ID_ESTADO_APROBACION_VALIDO)
				})
			}
			return Promise.resolve()
		}
		return this.checkInvalidChecklist()
	}

	// VEC-3990: true si el campo sigue teniendo el valor con el que se pidió la proyección.
	sigueVigente(valorConsultado) {
		return this.castValue(this.props.atributo[this.valueKey]) === valorConsultado
	}

	// VEC-3990: bloqueo por llantas que quedarían en negativo (aplica con la config on u off).
	bloquearPorLlantasEnCero(enCero) {
		let seriales = enCero.map(llanta => llanta.serial).join(', ')
		return this.avisar(this.t('InstanciaMedidor.bloqueo.llantas_en_cero', 'No se puede guardar: las llantas {llantas} quedarían con odómetro negativo.', { llantas: seriales })).then(() => {
			this.props.handleChange("estado", Constants.ID_ESTADO_APROBACION_INVALIDO)
		})
	}

	// VEC-3990: control del alta de checklist (tolerancia + proyección de llantas).
	checkInvalidChecklist() {
		let valor = this.castValue(this.props.atributo[this.valueKey])
		let kmActual = this.castValue(this.props.movil ? this.props.movil.km_actual : 0)
		// Sin odómetro previo no hay control. km_actual llega como texto ("0.000"), que castValue convierte
		// en 0 y no en '': por eso se pregunta por > 0 y no solo por ''.
		if (!valor || !(kmActual > 0)) return Promise.resolve()

		let tolerancia = getToleranciaOdometro()
		let habilitado = isControlOdometroHabilitado()
		let INVALIDO = Constants.ID_ESTADO_APROBACION_INVALIDO
		let VALIDO = Constants.ID_ESTADO_APROBACION_VALIDO

		if (superaTolerancia(valor, kmActual, tolerancia)) {
			if (habilitado) {
				return this.avisar(this.t('InstanciaMedidor.bloqueo.tolerancia', 'No se puede guardar: la diferencia del medidor supera la tolerancia de {tolerancia} unidades.', { tolerancia: tolerancia })).then(() => {
					this.props.handleChange("estado", INVALIDO)
				})
			}
			let avisoTolerancia = () => this.avisar(this.t('InstanciaMedidor.checkInvalid.titulo', 'La diferencia del medidor es mayor a {tolerancia} unidades.', { tolerancia: tolerancia })).then(isConfirm => {
				if (isConfirm)
					this.props.handleChange("estado", VALIDO)
			})
			// Con la config apagada una bajada grande igual puede dejar llantas en negativo, y eso el backend
			// lo rechaza siempre: se consulta antes de ofrecer el aviso que deja el valor como válido.
			if (valor < kmActual && this.props.movil && this.props.movil.id) {
				return fetchProyeccionOdometro(this.props.movil.id, valor).then(proyeccion => {
					if (!this.sigueVigente(valor)) return
					if (proyeccion && proyeccion.llantas_en_cero && proyeccion.llantas_en_cero.length > 0)
						return this.bloquearPorLlantasEnCero(proyeccion.llantas_en_cero)
					return avisoTolerancia()
				}).catch(() => {
					if (this.sigueVigente(valor)) return avisoTolerancia()
				})
			}
			return avisoTolerancia()
		}

		if (valor < kmActual && this.props.movil && this.props.movil.id) {
			return fetchProyeccionOdometro(this.props.movil.id, valor).then(proyeccion => {
				// El operador pudo cambiar el valor mientras se consultaba: no se muestra una proyección vieja.
				if (!proyeccion || !this.sigueVigente(valor)) return
				let enCero = proyeccion.llantas_en_cero || []
				let llantas = proyeccion.llantas || []
				if (enCero.length > 0) {
					return this.bloquearPorLlantasEnCero(enCero)
				}
				if (habilitado && llantas.length > 0) {
					return swal({
						title: this.t('InstanciaMedidor.proyeccion.titulo', 'Al bajar el odómetro se modificará el de estas llantas'),
						icon: "warning",
						content: this.armarTablaProyeccion(llantas),
						buttons: {
							cancel: {
								text: this.t('InstanciaMedidor.proyeccion.cancelar', 'Cancelar'),
								value: false,
								visible: true,
								className: "btn btn-secondary",
								closeModal: true
							},
							confirm: {
								text: this.t('InstanciaMedidor.proyeccion.confirmar', 'Confirmar'),
								value: true,
								visible: true,
								className: "btn btn-success",
								closeModal: true
							},
						}
					}).then(isConfirm => {
						if (isConfirm) {
							this.props.handleChange("estado", VALIDO)
						} else {
							this.props.handleChange(this.valueKey, '')
							this.props.handleChange("estado", Constants.ID_ESTADO_APROBACION_SIN_COMPROBACION)
						}
					})
				}
			}).catch(() => {
				// Si el fetch falla no se bloquea: el backend valida igual al guardar.
			})
		}

		return Promise.resolve()
	}

	castValue(value) {
		if (this.props.previsualizacion)
			return ''
		if (value) {
			if (isNaN(value))
				return 0
			else 
				return Number(value)
		} else
			return ''
	}
	masData() {

		let labelFinal = "";
		let labelUser = "";
		let labelFecha = "";
		if(this.props.movil){
			let fecha = this.props.movil.fecha_hora_km_modificacion
			let usuario = this.props.movil.usuario_km_modificacion


			if (usuario)
				labelUser = "Usuario: " + usuario.label

			if (fecha) {
				let ahora = moment()
				let dias = ahora.diff(moment(fecha), 'days')
				let horas =  ahora.diff(moment(fecha), 'hours')
				if (dias)
					labelFecha = dias + " días";
				else
					labelFecha = horas + " horas";
				labelFecha = 'hace ' + labelFecha ;
			}
			labelFinal = [labelUser, labelFecha].filter(label => label).join(' | ')
		}
		if (labelFinal.length)
			labelFinal = '(' + labelFinal + ')'
		return labelFinal
	}

	onChangeInput(e){
		let target = e.target;
		let value = target.type === 'checkbox' ? target.checked : target.value;
		if(value >= 0){
			this.handleInputChange(e)
		}
	}

	render() {
      	return (
			<React.Fragment>
				<>
					<input
						disabled={this.props.disabled || this.props.previsualizacion}
						type="number"
						min="0"
						className="form-control"
						value={this.props.atributo[this.valueKey]}
						onChange={e => this.onChangeInput(e)}
						onBlur={this.checkInvalid}
					/>
					{ (this.props.movil && this.props.movil.km_actual) &&
						<p className='pt-1'>
						<FormattedMessage 
							id="InstanciaMedidor.render.ultima_modificacion_medidor"
							defaultMessage="Última Modificación del Medidor"
						/>: {Math.floor(this.props.movil.unidadMedidorId === ID__UM_ODOMETRO ? UnitSystem.toDisplay(this.props.movil.km_actual, 'distance') : this.props.movil.km_actual)} {UNIDAD_MEDIDOR[this.props.movil.unidadMedidorId]['unidades']} {this.masData()}</p>
					}
				</>
			</React.Fragment>
		)
		}
}

export default injectIntl(InstanciaMedidor);
